document.addEventListener('DOMContentLoaded', function () {
    const swiperEl = document.querySelector('.hero-slider .swiper');

    if (!swiperEl) return;

    const slideDuration = parseInt(
        swiperEl.dataset.slideDuration || 5000,
        10
    );

    const swiper = new Swiper(swiperEl, {
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        autoplay: {
            delay: slideDuration,
            disableOnInteraction: false,
        },
        speed: 1000,
    });
});